// TODO: switch over use of this to constants provided by webpack like _OL_ORIGIN
const dataLoader = document.getElementById('site-url-data');
const dataJSON = dataLoader ? dataLoader.textContent : 'null';

export const data = JSON.parse(dataJSON);
